import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton, CHECKOUT_URL } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-37" data-mp="vmcy5lnqs4jr">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center border-brand-goldDark/25 relative overflow-hidden" data-id="element-38" data-mp="vll4igdpggw4">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-purple/10 rounded-br-full -z-10" data-id="element-39" data-mp="qmqk5a03ak9w"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-tl-full -z-10" data-id="element-40" data-mp="mn9d4c50lf2m"></div>

        <h2 className="text-3xl md:text-5xl font-serif font-semibold mb-8 text-brand-burgundy leading-tight" data-id="element-41" data-mp="hlaaj4h3mm6q">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text mb-10 max-w-2xl mx-auto" data-id="element-42" data-mp="7ppd7jmz6a3b">
          <p data-id="element-43" data-mp="2708dauencdaz">
            Una que cierra esta página y la próxima sesión sigue sin saber
            exactamente qué serie prescribir, cómo estructurar la sesión y cómo
            proteger su propio campo energético.
          </p>
          <p className="font-medium text-brand-purple" data-id="element-44" data-mp="354lvi60jnddm">
            Y otra que decide que hoy es el día en que su práctica de Chi Kung
            cambia para siempre.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-goldDark" data-id="element-45" data-mp="2v5wba6l6dgu7">
            La pregunta no es si podés pagarlo.
            <br data-id="element-46" data-mp="3nt0jsljh8daq" />
            La pregunta es cuántas sesiones más vas a trabajar sin un sistema
            clínico que te respalde.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-47" data-mp="3srk6wp9t3v4o">
          <div className="rounded-2xl p-6 md:p-8 border border-brand-gold/40 bg-brand-purpleDark text-center flex flex-col relative shadow-2xl" data-id="element-48" data-mp="3e3gzdbg48bdr">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-burgundy text-brand-surface text-[10px] md:text-xs font-display font-semibold uppercase tracking-[0.2em] px-4 py-1 rounded-sm whitespace-nowrap shadow-md" data-id="element-49" data-mp="3j0z9341yiumt">
              Más elegido
            </div>
            <h4 className="font-display font-semibold uppercase tracking-[0.2em] text-sm md:text-base text-brand-goldLight mb-2 mt-2" data-id="element-50" data-mp="p9fkob4mt57d">
              Mega Pack Chi Kung
            </h4>
            <div className="font-serif text-4xl md:text-5xl font-semibold text-brand-surface mb-4" data-id="element-51" data-mp="g7zmd1r3ctji">
              $24.990 ARS
            </div>
            <p className="text-sm md:text-base text-brand-surfaceLight/80 mb-7 flex-grow px-2 leading-relaxed" data-id="element-52" data-mp="b94vdciyzyob">
              3 Tomos + 6 Bonus · Más de 190 páginas. El sistema integral de
              sesiones pre-diseñadas y blindaje para el terapeuta profesional.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-4 shadow-lg ring-1 ring-brand-burgundy/50 ring-offset-2 ring-offset-brand-purpleDark" href={CHECKOUT_URL} variant="purple" data-id="element-53" data-mp="3sqpiqzjkvn0t">
              Quiero mi Mega Pack $24.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-54" data-mp="1u8cj9p5fbblz">
          <div className="flex items-center" data-id="element-55" data-mp="1z64asi25ovpn">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-56" data-mp="1z99xjqnbbli7" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-57" data-mp="244fhijx5mq3n">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-58" data-mp="286u49f3y2a07" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-59" data-mp="1biw90a3xs4sd">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-60" data-mp="1ggpcuwhromph" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-61" data-mp="1kij7oo5a6whq">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-62" data-mp="1kgq27c6emibb" /> Mercado
            Pago | Tarjeta
          </div>
        </div>

        <div className="text-sm text-brand-text bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-purple/20 space-y-3 text-left md:text-center" data-id="element-63" data-mp="sr3cw6tkm3gf">
          <p data-id="element-64" data-mp="wr5gwmms38yv">
            <strong className="text-brand-purpleDark" data-id="element-65" data-mp="wqlxt2le6ej9">P.D.:</strong> Si tenés
            dudas, escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-goldDark hover:underline font-medium" data-id="element-66" data-mp="dlqt4zvqp077">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-goldDark hover:underline font-medium" data-id="element-67" data-mp="im54orwjus9z">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="italic text-brand-goldDark" data-id="element-68" data-mp="rhujuj7emqex">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu
            sistema clínico de Chi Kung es ahora.
          </p>
        </div>
      </div>
    </Section>;
};